import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "request col-4 mx-auto mb-4 mt-5" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "パスワード再設定")
], -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("small", { class: "form-text text-muted" }, "メールに記載されている確認コードを入力してください。", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-center my-3" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary col-4",
    type: "submit"
  }, "変更")
], -1)

import { ref, unref } from 'vue'
  import { useRouter } from 'vue-router'
  import { useNicotto } from '@/plugins/nicotto'
  import { useMessenger } from '@/plugins/message'
  import { Buffer } from 'buffer'
  import { useRoute} from "vue-router";
  import { useValidateForm } from '@/components/ui/validator'
  import FormGroup from '@/components/ui/FormGroup.vue'
  import InputEmail from '@/components/ui/InputEmail.vue'
  import InputText from '@/components/ui/InputText.vue'
  import InputPassword from '@/components/ui/InputPassword.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmView',
  setup(__props) {

  const email = ref('')
  const code = ref('')
  const password = ref('')
  const emQuery = ref(false)

  const formRef = ref<HTMLFormElement|null>(null)
  const router = useRouter()
  const nicotto = useNicotto()
  const messenger = useMessenger()

  const forgotPasswordSubmit = async() => {
    const form = unref(formRef) as unknown as HTMLFormElement
    if (useValidateForm(form).isValid()) {
      try {
        await nicotto.auth.forgotPasswordSubmit(email.value, code.value, password.value)
        router.push('/forgot/complete')
      } catch (err) {
        if (err && typeof err == "object" && Object.keys(err).length != 0) {
          for (const [key, val] of Object.entries(err)) {
            if (key=="name") {
              switch (val) {
                case "LimitExceededException": //実行制限（リクエスト数/h）
                  messenger.set('forgot.retryLater')
                  break
                case "ExpiredCodeException": //使用回数制限（使用済み）
                  messenger.set('forgot.retrySendCode')
                  router.push('/forgot')
                  break
                case "UserNotFoundException": //存在しないユーザ
                  messenger.set('forgot.retrySendCode')
                  router.push('/forgot')
                  break
                default: //認証コード間違い
                  messenger.set('forgot.emailAuthError')
                  break
              }
              return false
            }
          }
        }
        messenger.set('forgot.emailAuthError')
      }
    }
  }

  const route = useRoute()
  if (route.query) {
    // email
    if (route.query.em && typeof route.query.em=="string") {
      email.value = Buffer.from(route.query.em, 'base64').toString()
      //Query emが存在する時、emailにdisabledを付与
      emQuery.value = true
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(forgotPasswordSubmit, ["prevent"]),
          ref_key: "formRef",
          ref: formRef,
          class: "formTable",
          novalidate: ""
        }, [
          _createVNode(FormGroup, {
            label: "メールアドレス",
            required: true,
            "label-for": "email",
            horizontal: false
          }, {
            default: _withCtx(() => [
              _createVNode(InputEmail, {
                modelValue: email.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                label: "メールアドレス",
                autocomplete: "username",
                disabled: emQuery.value,
                required: true
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(FormGroup, {
            label: "確認コード",
            required: true,
            "label-for": "code",
            horizontal: false
          }, {
            default: _withCtx(() => [
              _createVNode(InputText, {
                modelValue: code.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((code).value = $event)),
                label: "確認コード",
                pattern: "^[0-9]+$",
                autocomplete: "code",
                required: true
              }, null, 8, ["modelValue"]),
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(FormGroup, {
            label: "パスワード",
            required: true,
            "label-for": "password",
            horizontal: false
          }, {
            default: _withCtx(() => [
              _createVNode(InputPassword, {
                modelValue: password.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
                autocomplete: "new-password",
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _hoisted_7
        ], 40, _hoisted_5)
      ])
    ])
  ]))
}
}

})